import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { store } from '../../store';
import Moment from 'moment';
import { get as _get, startCase, isEqual, isObject } from 'lodash';

import api from '../../store/api/api';

import FloatHeader from '../theme/headers/FloatHeader';

import { getUUID } from '../../utils/hashAndUuid';
import FeedbackTile from '../theme/modals/FeedbackTile';
import BaseModal from '../theme/modals/BaseModal';
import BaseForm from '../theme/forms/BaseForm';
import ScriptDisplay from '../theme/scripts/scriptDisplay';
import { Link } from 'react-router-dom';
import Input from '../theme/forms/Input';
import * as formFields from '../../utils/forms/formFields';
import NoteTagList from '../theme/buttons/NoteTag';

//form for creating script elements
class CreateElementForm extends Component {
  constructor(props) {
    super(props);

    this.defaultInputs = [
      {
        type: 'text',
        title: 'Name',
        dataKey: 'display_name',
        placeholder: 'Use something descriptive',
        value: props?.editing_element?.display_name,
      },
      {
        type: 'text',
        title: 'Prompt',
        dataKey: 'prompt',
        placeholder: '',
        value: props?.editing_element?.prompt,
      },
    ];

    this.state = {
      inputs: [...this.defaultInputs],
      editing_element: {},
    };

    this.form = React.createRef();
    this.scriptDisplayRef = React.createRef();
  }

  static defaultProps = {
    editing_element: {},
    script_elements: [],
    onSubmit: () => null,
    onCancel: () => null,
  };

  componentDidMount() {
    //we need to move editing_element to state, because we update that value dynamically.
    let { editing_element } = this.props;

    //element came from a creation button. We define the basics here.
    if (!editing_element.element_hash) {
      editing_element = {
        ...editing_element,
        display_name: startCase(editing_element.element_type_config?.name),
        element_hash: getUUID().split('-')[0],
        ...this.getNewElementDefaultPosition(),
        prompt: '',
        elementtype: editing_element.element_type_config?.name,
        iconClass: editing_element.element_type_config?.iconClass,
        connectors: [],
      };
    }

    this.setState({ editing_element }, () => {
      if (editing_element.element_type_config.defineResponses) {
        this.addResponseInput();
      }
    });
  }

  getNewElementDefaultPosition = () => {
    const pos_top_default =
      Math.min(...this.props.script_elements.map((d) => d.pos_top)) +
      50 +
      this.props.script_elements.length * 10;
    const pos_left_default =
      Math.min(...this.props.script_elements.map((d) => d.pos_left)) +
      50 +
      this.props.script_elements.length * 10;

    return {
      pos_top: pos_top_default,
      pos_left: pos_left_default,
    };
  };

  getResponseOptionDataKey = (index) => `response__${index}`;

  getResponseOptionTitle = (index) => (
    <div className={'m-0 full-width flx space_between'}>
      <span>Response Option {index + 1}</span>
      {/* only show this if there is more than one response option*/}
      <i
        className={'danger-text fas fa-minus-circle is-clickable mr-1'}
        onClick={(e) => {
          e.stopPropagation();
          this.removeResponseInput(index);
        }}
      />
    </div>
  );

  addResponseInput = (adding = false) => {
    // this is a new element that we are creating
    if (!this.props?.editing_element?.connectors || adding) {
      let curr_index = this.state.inputs.length - this.defaultInputs.length; // length of inputs, minus the two that are there (name and prompt)
      this.addResponseOptionToEditingElement();

      this.setState({
        inputs: [
          ...this.state.inputs,
          {
            type: 'text',
            title: this.getResponseOptionTitle(curr_index),
            dataKey: this.getResponseOptionDataKey(curr_index),
            resp_idx: curr_index,
            placeholder: '',
          },
        ],
      });

      // loading an existing element, normally called on mount
    } else {
      let inputs = [...this.state.inputs];
      this.props.editing_element.connectors.forEach((c, i) => {
        inputs.push({
          type: 'text',
          title: this.getResponseOptionTitle(i),
          dataKey: this.getResponseOptionDataKey(i),
          resp_idx: i,
          value: c.value_text,
        });
      });
      this.setState({ inputs });
    }
  };

  addResponseOptionToEditingElement = () => {
    let { editing_element } = this.state;

    // we default the connection to the next element hash of the connector in front of it.
    let next_el_hash =
      editing_element.connectors?.[editing_element.connectors.length - 1]?.next_el_hash;

    editing_element.connectors.push({
      ordinal_position: editing_element.connectors.length + 1,
      value_text: null,
      next_el_hash,
      key: null, // key updates when we have a value
    });
  };

  removeResponseInput = (resp_idx) => {
    let { inputs, editing_element } = this.state;

    if (editing_element.connectors.length === 1) {
      this.setState({ errMsg: 'You must have at least one response for this element.' });
      setTimeout(() => this.setState({ errMsg: null }), 2000);
      return;
    }

    //filter and reupdate their ordinal keys.
    inputs = inputs
      .filter((d, i) => d.dataKey !== this.getResponseOptionDataKey(resp_idx))
      .map((d, i) => {
        if (i < this.defaultInputs.length) return d;
        let resp_idx = i - this.defaultInputs.length;
        return {
          ...d,
          resp_idx,
          title: this.getResponseOptionTitle(resp_idx),
          dataKey: this.getResponseOptionDataKey(resp_idx),
        };
      });

    //filter out editing element and update the keys to force a refresh react side.
    editing_element.connectors = editing_element.connectors
      .filter((d, i) => i !== resp_idx)
      .map((d) => ({ ...d, key: d.key + '-' + Math.round(Math.random() * 10000000) }));

    // to do : editing_element is not in state, it's in props. =P
    this.setState({
      inputs,
      editing_element,
    });
  };

  onValueChange = (dataKey, val) => {
    let { editing_element } = this.state;

    if (dataKey.startsWith('response__')) {
      let resp_idx = +dataKey.split('__')[1];
      if (isNaN(resp_idx)) {
        console.error('Unable to get the index of the updated response. DataKey: ', dataKey);
        return;
      }

      let targetResp = editing_element?.connectors[resp_idx];
      if (!targetResp || !isObject(targetResp)) {
        console.error('Could not find target response on update');
        return;
      }

      targetResp = {
        ...targetResp,
        value_text: val,
        key: `${val}-${editing_element.element_hash}`,
      };
      editing_element.connectors[resp_idx] = targetResp;
    } else {
      editing_element[dataKey] = val;
    }

    this.setState({ editing_element });
  };

  onCreateElementSubmit = () => {
    let { editing_element } = this.state;

    //filter our elements without values
    editing_element.connectors = editing_element.connectors.filter(
      (d) => d.value_text && d.value_text.length
    );

    this.props.onSubmit(this.state.editing_element);
  };

  render() {
    let element_type_config = this.props.editing_element.element_type_config;

    let otherButtons = this.props.editing_element.element_hash
      ? [
          <button type={'button'} className={'button danger'} onClick={this.props.onDeleteElement}>
            Delete Element
          </button>,
        ]
      : [];

    return (
      <>
        <div className={'mx-5 mb-4 is-border-underlined'}>
          <h6 className={'m-0 pb-2'}>
            <i className={element_type_config.iconClass + ' mr-3'} />
            Add a {startCase(element_type_config.name)} element
          </h6>
        </div>
        {this.state.errMsg && (
          <p className={'danger-text mx-1 mx-5 is-size-6'}>{this.state.errMsg}</p>
        )}

        <BaseForm
          ref={this.form}
          className={'my-0 sidebar-form'}
          inputs={this.state.inputs}
          onCancel={this.props.onCancel}
          onSubmit={this.onCreateElementSubmit}
          onValueChange={this.onValueChange}
          otherButtons={otherButtons}
        >
          {element_type_config.defineResponses && (
            <div className={'button-wrapper mb-2'}>
              <div
                className={'button button-clear m-0 pl-0'}
                onClick={() => this.addResponseInput(true)}
              >
                + Response Option
              </div>
            </div>
          )}
        </BaseForm>
      </>
    );
  }
}

class ScriptEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      errMsg: "Doesn't work yet.",
      editing_element: null,
      script_metadata: {},
      script_elements: [],
      script_revisions: [],
      displayed_revision: null,
    };

    this.elementTypes = [
      {
        id: 1,
        name: 'speech',
        iconClass: 'fas fa-quote-left',
      },
      {
        id: 2,
        name: 'question',
        iconClass: 'fas fa-question',
        defineResponses: true,
      },
      {
        id: 4,
        name: 'phone',
        iconClass: 'fas fa-phone',
      },
      {
        id: 5,
        name: 'email',
        iconClass: 'fas fa-at',
      },
      {
        id: 6,
        name: 'text',
        iconClass: 'fas fa-pencil-alt',
      },
      {
        id: 7,
        name: 'signature',
        iconClass: 'fas fa-signature',
      },
      {
        id: 8,
        name: 'barcode',
        iconClass: 'fas fa-barcode',
      },
      {
        id: 17,
        name: 'image',
        iconClass: 'far fa-image',
      },
      {
        id: 18,
        name: 'docscan',
        iconClass: 'far fa-file-alt',
      },
      {
        id: 20,
        name: 'docscan_w_barcode',
        iconClass: 'far fa-file-alt',
      },
      {
        id: 19,
        name: 'multiselect',
        iconClass: 'far fa-list-alt',
        defineResponses: true,
      },
    ];
  }

  componentDidMount() {
    const {
      match: {
        params: { script_id },
      },
    } = this.props;

    this.setState({ loading: true });
    api
      .get('/script/', { s: script_id })
      .then((res) => {
        console.log(res.data);
        this.onLoadScriptData(res.data);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
    // this.onLoadScriptData(sampleData)
  }

  _isError = () => {
    return this.state.error;
  };

  _isLoading = () => {
    return this.state.loading;
  };

  onCreateElementRequest = (element_type_config) => {
    this.setState({
      editing_element: { element_type_config },
    });
  };

  onEditElementRequest = (element) => {
    //set to null and then back to make sure it updates if we were just updating another element.
    this.setState({ editing_element: null }, () =>
      this.setState({
        editing_element: {
          ...element,
          element_type_config: this.elementTypes.find((d) => d.name === element.elementtype) || {},
        },
      })
    );
  };

  onLoadScriptData = (script_data, revision_only = false) => {
    let script_metadata = script_data.script;
    let script_revisions = script_data.drafts;

    this.onLoadRevision(script_data.revision);

    this.setState({
      script_metadata,
      script_revisions,
      displayed_revision: script_metadata.draft_revision_id,
    });
  };

  onLoadRevision = (revision_data) => {
    let script_elements = revision_data.script_schema;
    script_elements.forEach((d) => {
      const match = this.elementTypes.find((e) => e.name === d.elementtype);
      if (match) {
        d.iconClass = match.iconClass;
        d.elementtype_id = match.elementtype_id;
      }
    });

    this.setState({ script_elements });
  };

  onSaveRevisionRequest = () => {
    this.setState({ loading: true });
    api
      .post('/script/', {
        schema: this.state.script_elements,
        script_id: this.state.script_metadata.id,
      })
      .then((res) => {
        this.setState({
          script_revisions: [res.data, ...this.state.script_revisions],
          displayed_revision: res.data.id,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onCreateEditElementSubmit = (element) => {
    let { script_elements: ses } = this.state;

    let existing_element_idx = ses.findIndex((d) => d.element_hash === element.element_hash);

    console.log('existing element idx', existing_element_idx, element);
    if (existing_element_idx >= 0) {
      ses[existing_element_idx] = element;
    } else {
      ses.push(element);
    }

    this.setState({ editing_element: null, script_elements: ses });
  };

  onDeleteElement = () => {
    let { script_elements: ses, editing_element: element } = this.state;

    ses = ses.filter((d) => d.element_hash !== element.element_hash);
    ses.forEach((d) => {
      d.connectors = d.connectors.map((c) =>
        c.next_el_hash === element.element_hash ? { ...c, next_el_hash: null } : c
      );
    });

    this.setState({ script_elements: ses, editing_element: null });
  };

  onDeleteResponseOption = (element_hash, connector) => {};

  _renderCreationButtons = () => {
    return (
      <>
        <div className={`side-menu-list-obj`}>
          <h6>
            Click on an element type below to add it. Double click on an existing element to edit
            it.{' '}
          </h6>
        </div>
        {this.elementTypes.map((d) => (
          <div
            className={`side-menu-list-obj`}
            key={d.name}
            onClick={() => this.onCreateElementRequest(d)}
            // onMouseEnter={this.props.onMouseEnter}
            // onMouseLeave={this.props.onMouseLeave}
          >
            <div className="list-obj-inner-wrapper" style={{ borderLeftColor: 'transparent' }}>
              <div className="obj-title">
                <i className={d.iconClass + ' mr-3'} />
                {startCase(d.name)}
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  _renderMenuBody = () => {
    if (this.state.editing_element) {
      return (
        <CreateElementForm
          {...this.state}
          onSubmit={this.onCreateEditElementSubmit}
          onCancel={() => this.setState({ editing_element: null })}
          onDeleteElement={this.onDeleteElement}
        />
      );
    } else {
      return this._renderCreationButtons();
    }
  };

  _getRevisionsSelector = () => {
    return (
      <Input
        className={'m-0'}
        type={'select'}
        options={this.state.script_revisions.map((d) => ({
          value: d.id,
          display: `${
            this.state.script_metadata.pub_revision_id === d.id ? '[ PUBLISHED ] ' : ''
          }Revision ${d.revision_num}   (${new Moment(d.created_at).format('MM/DD HH:mm')})`,
        }))}
        value={this.state.displayed_revision}
        onChange={this._handleRevisionSelection}
      />
    );
  };

  _handleRevisionSelection = (revision_id) => {
    this.setState({ displayed_revision: revision_id });

    api.get('/script-get-schema/', { sr: revision_id }).then((res) => {
      this.onLoadRevision(res.data);
    });
  };

  _renderMenu = () => {
    return (
      <div className={`map-side-menu ${this.state.sideBarClosed && 'closed'}`}>
        <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
          <div className="side-menu-title">
            <p className={'m-0'}>Editing Script</p>
            <h3 className={'primary-text mb-4'}>{this.state.script_metadata.name}</h3>
            {this._getRevisionsSelector()}
            <div className={'flx justify-end'}>
              <div
                className={`button button-clear m-0 p-0 align ${
                  this._isLoading() ? 'disabled' : ''
                }`}
                onClick={this.onSaveRevisionRequest}
              >
                Save
              </div>
            </div>
          </div>
          <div className={'side-menu-body'}>{this._renderMenuBody()}</div>
        </div>

        <div className={`side-menu-select-wrapper`} style={{ width: '1px' }}>
          {/*<div className={'side-menu-option'}>*/}
          {/*    <Link to={'/site-list'}>*/}
          {/*        <div*/}
          {/*            className={'button primary-milligram'}*/}
          {/*            onClick={() => null}*/}
          {/*        >*/}
          {/*            Response View*/}
          {/*        </div>*/}
          {/*    </Link>*/}
          {/*</div>*/}

          {this.state.loading && (
            <div className={`side-menu-option loading`}>
              <i className="fas fa-asterisk" />
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <FloatHeader link="/script" />

        <div className={'polka-back script-edit-wrapper'}>
          <ScriptDisplay
            ref={this.scriptDisplayRef}
            data={this.state.script_elements}
            is_editable={true}
            onEditElementRequest={this.onEditElementRequest}
            editingElement={this.state.editing_element}
          />
        </div>

        {this._renderMenu()}

        {this._isError() && (
          <FeedbackTile
            text={
              <div>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
                {this.state.errMsg}
              </div>
            }
            visible={true}
            classNames="danger clear-sidebar-feedback-tile"
          />
        )}

        {/*<BaseModal*/}
        {/*    title={`Edit ${this.state.editingInstance.name}`}*/}
        {/*    open={this.state.editModalOpen}*/}
        {/*    onClose={this.onCloseEditModal}*/}
        {/*    center*/}
        {/*>*/}
        {/*    <BaseForm*/}
        {/*        inputs={this.editFormInputs}*/}
        {/*        onCancel={this.onCloseEditModal}*/}
        {/*        onSubmit={this.handleUpdateCreateSubmission}*/}
        {/*    />*/}
        {/*</BaseModal>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ScriptEdit);

/*
* Speech
Question
Open Question
Phone
Email
Signature
Barcode
Image
*
* */

const sampleData = {
  id: '17',
  name: 'Missourians for Healthcare',
  script_elements: [
    {
      element_id: 227,
      display_name: 'START',
      element_hash: 'start',
      pos_top: 1015.0,
      pos_left: 990.0,
      prompt: '',
      elementtype: 'start',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 228,
          next_el_display_name: 'Scan Barcode',
          next_el_hash: 'u949c',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 228,
      display_name: 'Scan Barcode',
      element_hash: 'u949c',
      pos_top: 1147.0,
      pos_left: 1041.0,
      prompt: '',
      elementtype: 'barcode',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 229,
          next_el_display_name: 'Line Number',
          next_el_hash: '7ietk',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 229,
      display_name: 'Line Number',
      element_hash: '7ietk',
      pos_top: 1300.0,
      pos_left: 1100.0,
      prompt: '',
      elementtype: 'question',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '1',
        },
        {
          ordinal_position: 2,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '2',
        },
        {
          ordinal_position: 3,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '3',
        },
        {
          ordinal_position: 4,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '4',
        },
        {
          ordinal_position: 5,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '5',
        },
        {
          ordinal_position: 6,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '6',
        },
        {
          ordinal_position: 7,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '7',
        },
        {
          ordinal_position: 8,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '8',
        },
        {
          ordinal_position: 9,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '9',
        },
        {
          ordinal_position: 10,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '10',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 230,
      display_name: 'Cell Phone Number',
      element_hash: '7rooe',
      pos_top: 1469.0,
      pos_left: 1438.0,
      prompt: 'Enter voters cell phone number for campaign updates.',
      elementtype: 'phone',
      connectors: [],
      response_count: 0,
    },
  ],
};
